import React from "react";
import { computeScale, projBarLabels, layoutLabels } from "./utils";

export const ConfidenceBar = ({ data }) => {
  const { actualHR, projLow, projExpected, projHigh } = data;
  const scale = computeScale([actualHR, projLow, projExpected, projHigh]);
  const span = scale.max - scale.min;
  const toPct = (v) => `${((Math.max(scale.min, Math.min(scale.max, v)) - scale.min) / span) * 100}%`;

  const labels = layoutLabels(projBarLabels(data, (v) => `${v}`), scale);
  const maxRow = labels.reduce((m, l) => Math.max(m, l.row ?? 0), 0);

  return (
    <div style={{ position: "relative", height: 52 + maxRow * 28 }}>
      <div style={{ position: "absolute", top: 14, left: 0, right: 0, height: 6, background: "rgba(15,23,42,0.06)", borderRadius: 999 }} />

      {projLow != null && projHigh != null && (
        <div style={{
          position: "absolute", top: 14, height: 6, borderRadius: 999,
          left: toPct(projLow),
          width: `calc(${toPct(projHigh)} - ${toPct(projLow)})`,
          background: "linear-gradient(90deg, rgba(0,194,65,0.55), #00c241)",
          boxShadow: "0 1px 4px rgba(0,194,65,0.25)",
        }} />
      )}

      {actualHR != null && (
        <div style={{ position: "absolute", top: 14, left: toPct(actualHR), height: 6, transform: "translateX(-50%)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#fff", border: "1.5px solid rgba(15,23,42,0.45)" }} />
        </div>
      )}

      {projExpected != null && (
        <div style={{ position: "absolute", top: 4, left: toPct(projExpected), width: 2, height: 22, background: "#0f172a", transform: "translateX(-50%)", borderRadius: 1 }}>
          <div style={{ position: "absolute", top: -4, left: "50%", width: 8, height: 8, borderRadius: "50%", background: "#0f172a", transform: "translateX(-50%)" }} />
        </div>
      )}

      {labels.map(({ pct: labelPct, row = 0, text, sub, bold, dim }) => (
        <div key={sub} style={{
          position: "absolute",
          left: `${labelPct}%`,
          top: `${30 + row * 28}px`,
          transform: "translateX(-50%)",
          textAlign: "center",
          whiteSpace: "nowrap",
        }}>
          <div style={{ width: 1, height: `${4 + row * 28}px`, background: "rgba(15,23,42,0.18)", margin: `${-row * 28}px auto 4px` }} />
          <div style={{
            color: bold ? "#0f172a" : dim ? "rgba(15,23,42,0.5)" : "#00c241",
            fontSize: bold ? 13 : 11,
            fontWeight: bold ? 900 : 700,
            fontFamily: "Arial, sans-serif",
            letterSpacing: "-0.2px",
          }}>{text}</div>
          <div style={{ color: "rgba(15,23,42,0.4)", fontSize: 8, fontFamily: "Arial, sans-serif", textTransform: "uppercase", letterSpacing: 1, marginTop: 2 }}>{sub}</div>
        </div>
      ))}
    </div>
  );
};
